import { ClickScrollPlugin, OverlayScrollbars } from 'overlayscrollbars';
import type { UseOverlayScrollbarsParams } from 'overlayscrollbars-react';

export const DEFAULT_SCROLLBAR_PARAMS: UseOverlayScrollbarsParams = {
  options: {
    scrollbars: {
      theme: 'uniqkey-scrollbar-theme',
      clickScroll: true, // requires adding 'ClickScrollPlugin' to OverlayScrollbars' plugins
    },
  },
  defer: true,
};

export const loadCustomScrollbarPlugins = () => {
  OverlayScrollbars.plugin(ClickScrollPlugin);
};

const INITIALIZATION_ATTRIBUTE_KEY = 'data-overlayscrollbars-initialize';
const INITIALIZATION_ATTRIBUTE_VALUE = '';

export const CUSTOM_SCROLLBAR_INITIALIZATION_ATTRIBUTE = {
  [INITIALIZATION_ATTRIBUTE_KEY]: INITIALIZATION_ATTRIBUTE_VALUE,
};

export const setCustomScrollbarInitializationAttribute = (target?: HTMLElement) => {
  if (!target) {
    return;
  }
  target.setAttribute(INITIALIZATION_ATTRIBUTE_KEY, INITIALIZATION_ATTRIBUTE_VALUE);
};

export * from './interfaces';
